import React, { createContext, useContext, useState, useCallback } from 'react';
import { useAudioAlarm } from './useAudioAlarm';

const AlertContext = createContext(null);

export function AlertProvider({ children }) {
  const [activeAlert, setActiveAlert] = useState(null);
  const [liveAlertBadgeCount, setLiveAlertBadgeCount] = useState(0);
  const { playAlarm, stopAlarm } = useAudioAlarm();

  // Call this function to trigger a global system alert
  const triggerAlert = useCallback((alertData) => {
    setActiveAlert(alertData);
    playAlarm();
  }, [playAlarm]);

  const acknowledgeAlert = useCallback(() => {
    setActiveAlert(null);
    stopAlarm();
  }, [stopAlarm]);

  const incrementLiveAlertBadge = useCallback(() => {
    setLiveAlertBadgeCount((prev) => prev + 1);
  }, []);

  const clearLiveAlertBadge = useCallback(() => {
    setLiveAlertBadgeCount(0);
  }, []);

  // Expose setActiveAlert for backend incident integration (does NOT play alarm)
  const setAlertDirectly = useCallback((alertData) => {
    setActiveAlert(alertData);
  }, []);

  return (
    <AlertContext.Provider value={{
      activeAlert,
      triggerAlert,
      acknowledgeAlert,
      setActiveAlert: setAlertDirectly,
      liveAlertBadgeCount,
      incrementLiveAlertBadge,
      clearLiveAlertBadge,
    }}>
      {children}
    </AlertContext.Provider>
  );
}

export function useAlert() {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
}
